export let baseURL = process.env.BASE_API+"";



// WEBPACK FOOTER //
// ./src/api/baseURL.js